import React, { useState } from "react";
import theme from "../theme/theme1";

const HighlightsSection = () => {
  const images = [
    "https://velammalnexus.com/wp-content/uploads/2023/10/1000-X-800-1-1.jpg",
    "https://velammalnexus.com/wp-content/uploads/2023/10/1000-X-800-1-1.jpg",
    "https://velammalnexus.com/wp-content/uploads/2023/10/1000-X-800-1-1.jpg",
    "https://velammalnexus.com/wp-content/uploads/2023/10/1000-X-800-1-1.jpg",

  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const handlePrevImage = () => {
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === 0 ? images.length - 1 : prevIndex - 1
      );
      setIsTransitioning(false);
    }, 300); // Match the CSS transition duration
  };

  const handleNextImage = () => {
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
      setIsTransitioning(false);
    }, 300); // Match the CSS transition duration
  };

  return (

    <section
      className=" flex flex-col md:flex-row  w-fullpy-12 px-4 bg-gradient-to-r from-[#b3a369] to-[#f8f4e8] font-sans relative overflow-hidden"
      style={{ fontFamily: theme.fontFamily }}

    >
      {/* Soft Lighting Effects */}
      <div className="absolute inset-0 bg-radial-gradient-light"></div>

      {/* Parallax Scrolling Background */}
      <div className="absolute inset-0 bg-parallax-light"></div>


      <div className="w-full md:w-1/2 text-center md:text-left px-4 py-6">
        <h2 className="text-4xl font-bold text-[#13294b] mb-4">Highlights</h2>
        <p className="text-lg text-gray-700 mb-6 leading-relaxed text-justify">
          Discover the exceptional highlights of Velammal. Our programs and
          initiatives foster a culture of learning and development to ensure a
          bright future for your child. Experience our legacy of excellence and
          innovative facilities firsthand.Discover the exceptional highlights of
          Velammal. Our programs and initiatives foster a culture of learning
          and development to ensure a bright future for your child. Experience
          our legacy of excellence and innovative facilities firsthand.Our programs and initiatives foster a culture of learning
          and development to ensure a bright future for your child. Experience
          our legacy of excellence and innovative facilities firsthand.
        </p>
        <button className="px-4 py-2 bg-[#13294b] text-white font-semibold border border-[#13294B] rounded transition duration-300">
          Learn More &raquo;
        </button>

      </div>

      <div className="w-full md:w-1/2 relative flex justify-center items-center">
        <div
          className={`border-2 border-[rgb(19,41,75)] p-1 bg-white shadow-md transition-opacity duration-300 ${isTransitioning ? "opacity-0" : "opacity-100"
            }`}
        >
          <img
            src={images[currentImageIndex]}
            alt={`Highlight ${currentImageIndex + 1}`}
            className="w-full h-full object-cover"
          />
        </div>

        <button
          onClick={handlePrevImage}
          className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-[rgb(19,41,75)] text-white p-2 rounded-full hover:bg-gray-700 transition duration-300"
          aria-label="Previous"
        >
          &#8592;
        </button>
        <button
          onClick={handleNextImage}
          className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-[rgb(19,41,75)] text-white p-2 rounded-full hover:bg-gray-700 transition duration-300"
          aria-label="Next"
        >
          &#8594;
        </button>
      </div>
    </section>


  );
};

const SupportiveNetworkSection = () => (

  <div className="bg-[#13294B] text-white w-full mx-0 flex flex-col md:flex-row items-center shadow-lg">
    <div className="w-full md:w-1/2">
      <img
        src="https://grad.gatech.edu/sites/default/files/2022-12/Global.jpg"
        alt="Supportive Network"
        className="w-full h-full object-cover"
      />
    </div>

    <div className="w-full md:w-1/2 text-center md:text-left p-6">
      <h2
        className="text-3xl font-bold mb-4 text-white relative" style={{ paddingBottom: '9px' }}
      >
        Strong Support Network for Students


        {/* <span
            className="absolute left-0 bottom-0 w-[89%] h-[8px] bg-[#c5b358] mt-[8px]"
          ></span> */}

      </h2>



      <p className="text-lg mb-4 leading-relaxed">
        Velammal School’s vibrant community offers guidance, mentorship, and
        engaging activities to support each student's journey. Join our network
        and connect with peers, educators, and mentors who are committed to
        helping you excel academically and personally.
      </p>
      <button className="px-4 py-2 bg-[#a4925a] text-white font-semibold border border-[#13294B] rounded transition duration-300">
        Learn More &raquo;
      </button>
    </div>
  </div>
);



const PageContent = () => (
  <div className="w-full">
    <SupportiveNetworkSection />
    {/* Campus Life Section */}
    <HighlightsSection />
  </div>
);

export default PageContent;
